import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'integrationsList',
    'integration',
    'input',
    'filter',
    'categoryFilter',
    'connectionTypeFilter',
    'noResults'
  ]

  bindInputs(event) {
    const { checked } = event.currentTarget
    const { filterName } = event.params
    const matchedInputs = this.filterTargets.filter(
      el => el.dataset.name === filterName
    )

    matchedInputs.forEach(el => (el.checked = checked))
  }

  filterResults(_event) {
    let matchedResultsCount = 0
    const searchQuery = this.inputTarget.value.trim().toLowerCase()
    let activeConnectionTypes = []
    let activeCategories = []

    if (this.hasConnectionTypeFilterTarget) {
      const checkedConnectionTypes = this.connectionTypeFilterTargets
        .filter(input => input.checked)
        .map(input => input.dataset.name)

      // remove duplicate values using Set since there are multiple checkboxes
      // that control the same value
      activeConnectionTypes = Array.from(new Set(checkedConnectionTypes))
    }

    if (this.hasCategoryFilterTarget) {
      const checkedCategories = this.categoryFilterTargets
        .filter(input => input.checked)
        .map(input => input.dataset.name)

      // remove duplicate values using Set since there are multiple checkboxes
      // that control the same value
      activeCategories = Array.from(new Set(checkedCategories))
    }

    this.integrationTargets.forEach(integration => {
      const name = integration.dataset.name.toLowerCase()
      const connectionTypes = integration.dataset.connectionTypes?.split(' ')
      const categories = integration.dataset.categories.split(' ')

      const matchesConnectionType =
        !this.hasConnectionTypeFilterTarget ||
        activeConnectionTypes.length === 0 ||
        connectionTypes.some(type => activeConnectionTypes.includes(type))

      const matchesCategory =
        !this.hasCategoryFilterTarget ||
        activeCategories.length === 0 ||
        categories.some(category => activeCategories.includes(category))

      const matchesSearch = searchQuery === '' || name.includes(searchQuery)

      const shouldShow =
        matchesConnectionType && matchesCategory && matchesSearch

      integration.hidden = !shouldShow
      matchedResultsCount += shouldShow ? 1 : 0
    })

    this.integrationsListTarget.hidden = matchedResultsCount === 0
    this.noResultsTarget.hidden = matchedResultsCount > 0
  }
}
